import '../../styles/main.scss';
import '../../styles/pages/shop.scss';
import { i18n } from '../../../i18n/i18n.js';
import { componentLoader } from '../components/loadComponents.js';
import { setupNavigation } from '../utils/navMenu.js';
import { initProductCarousel } from '../utils/productCarousel.js';
import { initMarquee } from '../utils/marquee.js';

// 确保全局可以访问i18n
window.i18n = i18n;

// DOMContentLoaded 事件处理
document.addEventListener('DOMContentLoaded', async () => {
  // 加载页面组件
  await componentLoader.loadAllComponents();
  
  // 初始化多语言功能
  await i18n.init();
  
  // 设置导航菜单与高亮
  setupNavigation();

  // ===== Product carousels =====
  initProductCarousel('#countertopTrack');
  initProductCarousel('#stationFamilyTrack');
  initProductCarousel('#starterKitsTrack');
  initProductCarousel('#distributorsTrack');
  
  // ===== Supplementary Information: marquee =====
  initMarquee('.supplementary-marquee__track', {
    speed: 0.4,
    autoFill: true,
  });
});
